import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CurrReconciliationUI from '../../../components/superUser/nodalTxn/CurrReconciliationUI'

const CurrReconciliationPageUI = ({ context, accountNumber, txnList, bankTxnList,
  onCopyToClipboard, copyToClipboardText,
  on4412Click, onRefreshClick, onReconcileClick, reconcileSubmitted, successMsg, errorList,
  uploadMode, onUploadClick, onCancelUploadClick, onOtherUploadClick, onOtherCancelUploadClick, otherUploadMode, onOtherUpload, signedUrlApi, onUpload, onCheckboxAppTxnClick, onCheckboxBankTxnClick,
  selectedAppTxnId, selectedBankTxnId
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_recon' topnav='transactions' backLink='/su/accounts'
    headerText='Accounts' centered={!txnList && !bankTxnList} page='4412unrecon' dimension='w768'
  >
    {
      (!txnList && !bankTxnList) &&
      <SpinnerComponentUI />
    }
    {
      txnList && bankTxnList &&
      <CurrReconciliationUI
        context={context}
        accountNumber={accountNumber}
        txnList={txnList}
        bankTxnList={bankTxnList}
        on4412Click={on4412Click}
        reconcileSubmitted={reconcileSubmitted}
        onRefreshClick={onRefreshClick}
        onReconcileClick={onReconcileClick}
        successMsg={successMsg}
        errorList={errorList}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        onUploadClick={onUploadClick}
        onOtherUploadClick={onOtherUploadClick}
        onCheckboxAppTxnClick={onCheckboxAppTxnClick}
        onCheckboxBankTxnClick={onCheckboxBankTxnClick}
        selectedAppTxnId={selectedAppTxnId}
        selectedBankTxnId={selectedBankTxnId}
      />
    }

    <FileUploadModalSF
      context={context}
      uploadMode={uploadMode}
      onCancelClick={onCancelUploadClick}
      signedUrlApi={signedUrlApi}
      onUpload={onUpload}
    />

    <FileUploadModalSF
      context={context}
      uploadMode={otherUploadMode}
      onCancelClick={onOtherCancelUploadClick}
      signedUrlApi={signedUrlApi}
      onUpload={onOtherUpload}
    />

  </SuperUserTxnPageUI>

export default CurrReconciliationPageUI
